/**
 * Montagem das parcelas de uma matrícula, extraída de Pages/Mensalidades/index.vue para ser
 * usada também no modal da efetivação de pré-matrícula.
 *
 * A parcela de matrícula ocupa a vaga da primeira mensalidade: as mensalidades do intervalo são
 * montadas e a primeira é descartada. Com `somenteMensalidades` a parcela de matrícula já existe
 * (veio da pré-matrícula), então a vaga continua ocupada, mas nenhuma parcela de matrícula nova é
 * montada.
 */

export const campoEstaPreenchido = (valor) => valor !== null && valor !== undefined && valor !== "";

export const temValorPositivo = (valor) => campoEstaPreenchido(valor) && Number(valor) > 0;

export const diaEstaValido = (valor) => {
  const dia = Number(valor);
  return campoEstaPreenchido(valor) && Number.isInteger(dia) && dia >= 1 && dia <= 31;
};

export function formularioDeParcelasValido(form, somenteMensalidades = false) {
  return (
    (somenteMensalidades || temValorPositivo(form.valor_matricula)) &&
    temValorPositivo(form.valor_mensalidade) &&
    campoEstaPreenchido(form.mesInicio) &&
    campoEstaPreenchido(form.mesFinal) &&
    diaEstaValido(form.vencimento) &&
    campoEstaPreenchido(form.desconto_1) &&
    diaEstaValido(form.descontoDia) &&
    campoEstaPreenchido(form.desconto_2) &&
    diaEstaValido(form.descontoDia2) &&
    campoEstaPreenchido(form.desconto_3) &&
    diaEstaValido(form.descontoDia3)
  );
}

export function montarParcelas(form, matriculaId, somenteMensalidades = false, hoje = new Date()) {
  const anoAtual = hoje.getFullYear();
  const diaVencimento = form.vencimento;
  const desconto = form.desconto_1;
  const parcelas = [];
  const parcelasEMatricula = [];

  const dataPrimeiraParcela = new Date(anoAtual, form.mesInicio.id - 1, diaVencimento);

  for (let i = form.mesInicio.id - 1; i <= form.mesFinal.id - 1; i += 1) {
    const dataParcela = new Date(anoAtual, i, diaVencimento);
    const dataRef = dataParcela.toISOString().split("T")[0];
    const anoMes = dataRef.substring(0, 7);

    const ultimoDiaDoMes = new Date(anoAtual, i + 1, 0).getDate();
    const clampDia = (dia) => Math.min(Number(dia), ultimoDiaDoMes);
    const referenciaDoDia = (dia) =>
      dia ? `${anoMes}-${String(clampDia(dia)).padStart(2, "0")}` : null;

    parcelas.push({
      situacao: 0,
      numero: i + 1,
      referencia: dataRef,
      valor: form.valor_mensalidade - desconto,

      matricula: matriculaId,
      valorMensal: form.valor_mensalidade,
      data: dataRef,
      desconto_1: form.desconto_1,
      desconto_2: form.desconto_2,
      desconto_3: form.desconto_3,
      referencia_1: referenciaDoDia(form.descontoDia),
      referencia_2: referenciaDoDia(form.descontoDia2),
      referencia_3: referenciaDoDia(form.descontoDia3),
      vencimento: dataRef,
    });
  }

  const primeiraMensalidade = parcelas[0] || {};
  const dataMatricula = dataPrimeiraParcela.toISOString().split("T")[0];

  if (!somenteMensalidades) {
    parcelasEMatricula.push({
      situacao: 0,
      numero: 1,
      referencia: dataMatricula,
      valor: form.valor_matricula,

      matricula: matriculaId,
      valorMensal: form.valor_matricula,
      data: dataMatricula,
      desconto_1: form.desconto_1,
      desconto_2: form.desconto_2,
      desconto_3: form.desconto_3,
      referencia_1: primeiraMensalidade.referencia_1 || null,
      referencia_2: primeiraMensalidade.referencia_2 || null,
      referencia_3: primeiraMensalidade.referencia_3 || null,
      vencimento: dataMatricula,
    });
  }

  parcelas.shift(); // A vaga da primeira mensalidade é da parcela de matrícula.

  return [...parcelasEMatricula, ...parcelas];
}
